export default __webpack_public_path__ + "static/media/feature.fe0c4f20.png";